// Import Packages
import React, { useEffect, useState } from 'react';
import JsonTree from 'autommate-react-json-viewer';
import { useSetRecoilState } from 'recoil';
import { useTranslation } from 'react-i18next';

// Import Material UI Elements
import Tooltip from '@material-ui/core/Tooltip';

// Import state
import { alertState } from "../../../../../../recoil-store/recoil-state";

// Import CSS
import './Clipboard.css'

function Clipboard({ selectedVariable }) {
    const [jsonData, setJsonData] = useState({});
    const setAlert = useSetRecoilState(alertState);
    const { t } = useTranslation();

    const label = 'CONTENT.CONFIGURATION-FORM.ADVANCED-ACTIONS.ADVANCED-ASSIGN.';

    useEffect(() => {
        if (selectedVariable.default_value) {
            setJsonData(JSON.parse(selectedVariable.default_value))
        }
    }, []);

    const copyToClipboard = (keyPath) => {
        const path = findKeyPath(keyPath)
        navigator.clipboard.writeText(`##${path}##`)
        setAlert(alert => ({ ...alert, show: true, message: t(label + 'COPIED-TO-CLIPBOARD'), severity: 'success' }))
    }

    const findKeyPath = (keyPath) => {
        let path = selectedVariable.name;
        for (let i = 0; i < keyPath.length; i++) {
            path += `[${keyPath[i]}]`;
        }
        return path;
    }

    return (
        <JsonTree data={jsonData} expandable={true}
            labelRender={(keyPath, key, type, hasParent, hasChild) => <span>
                <Tooltip enterDelay={700} title={t(label + 'COPY-TO-CLIPBOARD')} placement="top">
                    <span className="top-2" style={{ cursor: 'pointer', borderRadius: '5px' }} color="primary"
                        onClick={() => copyToClipboard(keyPath)}>
                        <strong>"{key}"</strong> :
                    </span>
                </Tooltip>
            </span>} />
    )
}

export default Clipboard;
